import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import Modal from "react-bootstrap/Modal";
import { ProtectiveFunctionLocation } from "../models/protectiveFunctionLocation";
import { PSF_ProtectiveFunctionComments } from "../models/PSF_ProtectiveFunctionComments";
import { ccfByLocation, updateCcfByLocation } from "../psfHelpers";
import Draggable from "react-draggable";

interface Props {
  psfProtectiveFunctionComments: PSF_ProtectiveFunctionComments;
  location: ProtectiveFunctionLocation;
  onCloseModal: () => void;
  onSubmit: (updatedPsf: PSF_ProtectiveFunctionComments) => Promise<void>;
  zoom: number;
}

interface State {
  closeFocus: boolean;
}

export class CcfSpecModal extends React.Component<Props, State> {
  private ccfInputRef = React.createRef<HTMLInputElement>();

  constructor(props: Props) {
    super(props);
    this.state = { closeFocus: false };

  }

  zoom(value: number, unit: "px" | "em") {
    return `${value * this.props.zoom}${unit}`;
  }

  modalTitle = () => {
    const locationString = this.props.location.toString();
    const isInputConfig = locationString.startsWith("INP");
    const configNumber = locationString.charAt(locationString.length - 1);
    return isInputConfig
      ? `CCF Specification Input ${configNumber}`
      : `CCF Specification Action ${configNumber}`;
  };

  handleUpdateButtonClicked = () => {
    const newCcf = parseFloat(this.ccfInputRef.current.value);
    if (isNaN(newCcf)) {
      // TODO: alert the user
      return;
    }

    const updatedPsf = updateCcfByLocation(
      newCcf,
      this.props.location,
      this.props.psfProtectiveFunctionComments
    );
    this.props.onSubmit(updatedPsf).then(() => this.props.onCloseModal());
  };

  onMouseEnter = () => {
    this.setState({
      closeFocus: true
    });
  };

  onMouseLeave = () => {
    this.setState({
      closeFocus: false
    });
  };

  render() {
    const zoom = this.props.zoom;

    var closeClass = this.state.closeFocus
      ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover"
      : "ui-dialog-titlebar-close ui-corner-all";

    return (
      <Modal
        show={true}
        animation={false}
        centered={true}
        onEscapeKeyDown={this.props.onCloseModal}
        onHide={() => {
          /* don't allow hide via off-click*/
        }}
        size="lg"
        enforceFocus={true}
        style={{
          zIndex: 10001, background: "rgba(000, 000, 000, 0.5)"
        }}
      >
        <Draggable
          axis="both"
          handle=".ui-dialog-titlebar"
        >
        <div
          id="CcfModal"
          className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="ui-dialog-title-ccfaction3"
          style={{
            display: "block",
            zIndex: 10001,
            outline: "0px",
            height: "auto",
            width: "350px",
            left: `${zoom * 375}px`,
            top: `${zoom * 750}px`
      }}
    >
          <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
            <span className="ui-dialog-title" id="ui-dialog-title-ccfaction3">
              {this.modalTitle()}
            </span>
            <div className={closeClass}>
              <span
                className="ui-icon ui-icon-closethick"
                style={{ cursor: "pointer" }}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                onClick={this.props.onCloseModal}
              >
                close
              </span>
            </div>
          </div>
          <div
            id="ccfaction3"
            className="ui-dialog-content ui-widget-content"
            style={{
              display: "block",
              width: "auto",
              minHeight: "0px",
              height: "112.522px"
            }}
          >
            <span id="UserCCFAction3">User Specified CCF(%)</span>
            <span
              className="sil-tooltip"
              title="When explicitly modeling redundant architectures (e.g., 1oo2, 2oo3, 1oo3) in the GUI, this field is used to enter an appropriate amount of common cause to apply between the redundant channels.  Be aware that any device boxes entered within a channel may automatically have some common cause applied, depending on the voting architecture selected when configuring that device  and the parameters of the datasheet for that device."
            >
              ?
            </span>
            <br />
            <input
              name="uservalue_CCFdiva3"
              type="number"
              defaultValue={ccfByLocation(
                this.props.location,
                this.props.psfProtectiveFunctionComments
              )}
              id="uservalue_CCFdiva3"
              ref={this.ccfInputRef}
            />
            <div className="update-button-div" style={{ marginTop: "3px" }}>
              <input
                type="submit"
                name="CCFButtona3"
                value="Update"
                id="CCFButtona3"
                className="green-button edit-button"
                onClick={this.handleUpdateButtonClicked}
              />
            </div>
          </div>
          </div>
          </Draggable>
      </Modal>
    );
  }
}
